import React from "react";
import Swal from "sweetalert2";
import { useQuery, useMutation, useQueryClient } from "react-query";
import { useParams } from "react-router-dom";
import useApi from "../../hooks/useApi";
import usePagination from "../../hooks/usePagination";
import useApp from "../../hooks/useApp";

const RevokeRequest = () => {
  const { Paginate } = usePagination();
  const { api, abortSignal, auth } = useApi();
  const { status = "pending" } = useParams();
  const { showAlert } = useApp();

  const getRecords = async () => {
    try {
      const url = `/policies/policy-items/revoke-requests/${status}`;
      const { data } = await api.list(url);
      return data;
    } catch (error) {
      throw new Error("failed to fetch records");
    }
  };

  const { data: records, refetch } = useQuery(
    ["revocationRequests", auth, status],
    ({ queryKey }) => getRecords()
  );

  const handleApprove = async (id) => {
    const { isConfirmed } = await Swal.fire({
      title: "Are you sure?",
      text: "You want to approve!",
      icon: "warning",
      confirmButtonText: "Yes, Approve",
      showCancelButton: true,
    });

    if (isConfirmed) {
      try {
        const response = await api.update(
          `/policies/policy-items/request-revoke/${id}/approve`
        );
        if (response.ok) {
          showAlert("Approved", "success");
          refetch();
        }
      } catch (error) {
        console.error(error);
      }
    }
  };

  const handleDecline = async (id) => {
    const { isConfirmed } = await Swal.fire({
      title: "Are you sure?",
      text: "You want to decline!",
      icon: "warning",
      confirmButtonText: "Yes, Decline",
      showCancelButton: true,
    });

    if (isConfirmed) {
      try {
        const response = await api.update(
          `/policies/policy-items/request-revoke/${id}/decline`
        );
        if (response.ok) {
          showAlert("Declined", "success");
          refetch();
        }
      } catch (error) {
        console.error(error);
      }
    }
  };

  return (
    <div className="list-group bg-white">
      {records && Array.isArray(records) && records.length > 0 ? (
        records.map((record) => (
          <a
            key={record.id}
            href="#"
            className="list-group-item list-group-item-action"
            aria-current="true"
          >
            <div className="d-flex w-100 justify-content-between">
              <h5 className="mb-1">
                {record?.PolicyItem?.Policy?.Client?.name}
              </h5>
              <small>
                {record.status === "pending" && (
                  <div className="ms-auto text-center text-nowrap text-muted">
                    <button
                      className="btn btn-xs btn-hover btn-success me-2"
                      onClick={() => handleApprove(record.id)}
                    >
                      <i className="demo-pli-like fs-5 me-2"></i>Approve
                    </button>
                    <button
                      className="btn btn-xs btn-hover btn-danger"
                      onClick={() => handleDecline(record.id)}
                    >
                      Decline
                    </button>
                  </div>
                )}
              </small>
            </div>
            <p className="mb-1">
              {record?.PolicyItem?.Company?.name} -{" "}
              {record?.PolicyItem?.PolicyType?.name} (
              {record?.PolicyItem?.Product?.name})
            </p>
            <p>
              {record?.PolicyItem?.policyCurrency}{" "}
              {Number(record?.PolicyItem?.premium)} -{" "}
              {record?.PolicyItem?.duration} months
            </p>
            <p>{record?.createdAt}</p>
          </a>
        ))
      ) : (
        <div className="">No record found</div>
      )}
    </div>
  );
};

export default RevokeRequest;
